import './App.css';
import { Routes, Route } from 'react-router-dom';

import NavBar from './components/navbar';
import Home from './components/home';
import EmailPreventivo from './components/email';
import Footer from './components/footer';
import ChiSiamo from './components/chiSiamo';
import Regole3p from './components/regole3p';
import ReviewForm from './components/recensione';
import Contatti from './components/contatti';
import Serramenti from './components/prodotti';
import Privacy from './components/privacy';
import Prodotti from './components/prodotti';
function App() {
  return (
    <div className="flex flex-col min-h-screen">
      <NavBar />
      <main className='flex flex-col items-center flex-grow'>
        <div className='w-full max-w-[1400px]'>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/chi-siamo" element={<ChiSiamo/>} />
            <Route path="/regole-3p" element={<Regole3p />} />
            <Route path="/serramenti" element={<Serramenti />} />
            <Route path="/recensioni" element={<ReviewForm />} /> 
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/prodotti" element={<Prodotti />} />
            <Route path="/richiedi-preventivo" element={<EmailPreventivo />} />
            {/* <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} /> */}
          </Routes>
        </div>
        
      </main>
      <Footer />
      </div>
  );
}

export default App;